import { HomeController as controller } from './home.controller';
import template from './home.html';
import '../../common/ui/hero/hero';

export const homeComponent = {
  name: 'homeComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {}
};
